import { ssrApi } from 'api/ssr';
import { AllCasinosPage } from 'components/template/collection-casino';
import { allMetadata } from 'constants/metadata';
import { Routes } from 'constants/routes';
import { ISlot } from 'constants/types';
import { ParsedUrlQuery } from 'querystring';
import { getItemIdentifier } from 'utils/slug';
import {
  isValidEntity,
  notFoundResult,
  unwrapEntity,
} from 'utils/ssr-not-found';

export default function SlotCasinosForRealMoney({ slot }: { slot: ISlot }) {
  const { slotsForRealMoney } = allMetadata;

  return (
    <AllCasinosPage
      slotId={slot?._id}
      name={`${slot?.name}`}
      title={` ${slot?.name}`}
      canonicalUrl={Routes.slotForRealMoneyPage(getItemIdentifier(slot))}
      description={`${slotsForRealMoney?.description[0]} ${slot?.name} ${slotsForRealMoney?.description[1]}`}
    />
  );
}

export async function getServerSideProps({ query }: { query: ParsedUrlQuery }) {
  const { id } = query;

  const slot = await ssrApi.slots.getById(id?.toString());

  if (!isValidEntity(slot)) {
    return notFoundResult();
  }

  return {
    props: { slot: unwrapEntity(slot) },
  };
}
